import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { SideSheet, Position, Pane, Dialog } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
// import Lottie from 'lottie-react-web';
// import animation from '../../assets/json/clean.json';
import 'react-toastify/dist/ReactToastify.css';
import MaterialDatatable from "material-datatable";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import qs from 'qs';
import KeyboardBackspace from '@material-ui/icons/KeyboardBackspace';
import * as moment from "moment-timezone";
import Login from '../common/login';
const columns = [

    { field: "count", name: "العدد ", options: { filter: true, sort: true, } },
    { field: "name", name: "اسم المنتج", options: { filter: true, sort: true, } },
    { field: "id", name: "#", options: { width: 200, filter: true, sort: false, } },
];
const options = {
    selectableRows: false,
    responsive: 'scroll',
    rowCursorHand: false,
    sort: true,
    print: false,
    filter: false,
    download: true,
    onSearchChange: (e) => {
        console.log(e);
    },
    textLabels: {
        body: {
            noMatch: " لم يتم العثور على سجلات مطابقة",
            toolTip: "فرز",
        },
        pagination: {
            next: "الصفحة التالية",
            previous: "الصفحة السابقة",
            rowsPerPage: "عدد الصفوف",
            displayRows: "من",
        },
        toolbar: {
            search: "بحث",
            downloadCsv: "تنزيل",
            print: "Print",
            viewColumns: " التحكم بالاعمدة",
            filterTable: "فلتر",
        },
        filter: {
            all: "الكل",
            title: "فلتر",
            reset: "إعادة تعيين",
        },
        viewColumns: {
            title: "عرض الأعمدة",
            titleAria: "إظهار / إخفاء أعمدة الجدول",
        },

    }
}
const cookies = new Cookies();

class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: false,
            serch: false,
            total: '',
            total_items: 0,
            pages: [],
            shiper: [],
            total_orders: 0,
            items_cost: 0,
            orders_cost: 0,
            company: 'All',
            miss: 0,
            conf: 0,
            cen: 0,
            all: 0

        }
    }
    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: {
                root: {
                    //   backgroundColor: "#FF0000",
                    textAlign: 'right',
                },

            },
            MuiTableCell: {
                root: {
                    textAlign: 'right',

                },
                head: {
                    // backgroundColor: "#FF0000",
                }
            },

        }
    })
    componentDidMount() {


    }
    Orders() {
        var date1 = moment(document.getElementById('date1').value).format("YYYY-MM-DD HH:mm:00");
        var date2 = moment(document.getElementById('date22').value).format("YYYY-MM-DD HH:mm:00");
        let searchParams = new URLSearchParams(window.location.search)
        var param = searchParams.get("id")
        console.log(param);
        axios.get(host + `users/users/reports/${param}?from=${date1}&to=${date2}`)
            .then(res => {
            
                let arr = [];
                this.setState({
                    miss:res.data.miss,
                    conf:res.data.conf,
                    cen:res.data.cencald,
                    rec:res.data.rec,
                })

            })
            .catch(error => {
                console.log(error.response)
            });
        console.log(date1);
        console.log(document.getElementById('date22').value);
    }
    handleChangeFrom = date => {
        console.log(date);

        this.setState({
            from: date
        });
    };
    handleChangeTo = date => {
        this.setState({
            to: date
        });
    };
    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        // if (this.state.spin) {
                        return (
                            <div >
                                <div id='navDashContiner'>
                                <a  href={`/Employee`}><KeyboardBackspace style={{ color: '#fff', cursor: 'pointer',fontSize:35 }} /></a>

                                </div>

                                <div id='ContinerReportDatePages'>
                                    <Row id='RowReportDate' style={{ flexDirection: "row-reverse" }}>
                                        <Col id='ColReportDate' sm={12} md={4}>

                                            <DatePicker id='date1'
                                                showTimeSelect
                                                dateFormat="yyyy/MM/dd hh:mm aa"
                                                selected={this.state.from}
                                                onChange={this.handleChangeFrom}
                                            />
                                            <span style={{ marginLeft: 10 }}> : من&nbsp;</span>
                                        </Col>
                                        <Col id='ColReportDate' sm={12} md={4}>

                                            <DatePicker id='date22'

                                                showTimeSelect
                                                selected={this.state.to}
                                                dateFormat="yyyy/MM/dd hh:mm aa"
                                                onChange={this.handleChangeTo}
                                            />
                                            <span style={{ marginLeft: 10 }}> : الى &nbsp;</span>
                                        </Col>




                                        <Col id='ColReportDate' sm={12} md={4}>
                                            <div id='AddClientDeptBTN' onClick={() => {
                                                this.setState({ spin: true, serch: true })

                                                this.Orders()
                                            }}>بحث</div>
                                        </Col>
                                    </Row>
                                </div>


                                {!this.state.serch ? null : (
                                    <div>

                                        <div id='ContinerReportDate1' style={{ flexDirection: "row-reverse" }}>
                                            <div id='AddClientDeptBTN1' > الطلبات المستلمة</div>

                                            <div style={{ marginRight: 20 }}>{this.state.all}</div>

                                        </div>
                                        <br />
                                        <div id='ContinerReportDate1' style={{ flexDirection: "row-reverse" }}>
                                            <div id='AddClientDeptBTN12' style={{ background: "#28a745" }}>التأكيد</div>

                                            <div style={{ marginRight: 20 }}>{this.state.conf}</div>

                                        </div>

                                        <div id='ContinerReportDate1' style={{ flexDirection: "row-reverse" }}>

                                            <div id='AddClientDeptBTN13'>الغاء</div>
                                            <div style={{ marginRight: 20 }}>{this.state.cen}</div>

                                        </div>

                                        <div id='ContinerReportDate1' style={{ flexDirection: "row-reverse" }}>
                                            <div id='AddClientDeptBTN14' style={{ background: "#ffc107" }}>لايرد</div>
                                            <div style={{ marginRight: 20 }}>{this.state.miss}</div>
                                        </div>
                                    </div>

                                )}

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                        // }
                        // else {
                        //     return (
                        //         <div style={{ width: '100%', height: 'calc(100vh - 60px)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        //             <Lottie
                        //                 options={{
                        //                     animationData: animation
                        //                 }}
                        //             />
                        //         </div>
                        //     )
                        // }
                    }
                    }
                </Context.Consumer>
            )
        }
        else {
            return (
                <Login />
            )
        }
    }
}


export default Selles_Reports;